export const FUNC = [
  {
    name: '推荐橱窗',
    pro: '1'
  },
  {
    name: '优惠券',
    pro: '1'
  },
  {
    name: '到店礼',
    pro: '1'
  },
  {
    name: '咨询礼',
    pro: '1'
  },
  {
    name: '商家承诺（诺图标）',
    pro: '1'
  },
  {
    name: '订单可退（退图标）',
    pro: '1'
  },
  {
    name: '套餐热标',
    pro: '1'
  },
  {
    name: '小程序',
    pro: '1'
  },
  {
    name: '放心购·保证金',
    pro: '1'
  },
  {
    name: '预设问题',
    pro: '1'
  },
  {
    name: '多客服系统',
    pro: '1'
  },
  {
    name: '店铺数据分析(基础版)',
    pro: '1',
    key: 'marketDataAnalysis_basic'
  },
  {
    name: '店铺数据分析(详细版)',
    pro: '2',
    key: 'marketDataAnalysis_detail'
  },
  {
    name: '聚客宝',
    pro: '2'
  },
  {
    name: '微传单+',
    pro: '2'
  },
  {
    name: '主题模板（高级装修功能）',
    pro: '2'
  },
  {
    name: '天眼系统',
    pro: '2'
  },
  {
    name: '潜在客资转化',
    pro: '2',
    key: 'kezi'
  },
  {
    name: '微官网',
    pro: '2'
  },
  {
    name: '多店管理',
    pro: '2'
  },
  {
    name: '商家端电子请帖',
    pro: '2'
  }
]
